import React from 'react';
import styled from 'styled-components';
import { useEditorSessionObserver } from '../../canvas/EditorSession';
import { ParticipantManager } from '../../canvas/participants/ParticipantManager';
import { useResolve } from '../../Container';
import { FollowingInfo } from './FollowingInfo';

const Frame = styled.div<{ color: string }>`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    border: solid .5rem ${p => p.color};
`;

export const FollowFrame = () => {
    const { userId } = useEditorSessionObserver(FollowingInfo);
    const ptpt = useResolve(ParticipantManager).get(userId);
    return !!ptpt ? <Frame color={ptpt.color} /> : null;
};
